import { useContext } from "react";
import FormContext from "../../context/FormContext";
import Header from "../header/Header";
import Sidebar from "../operator_home/sidebar/Sidebar";
import TaskSummary from "../operator_home/task-summary/TaskSummary";
import AddBox from "../operator_home/AddBox";
import RecentEntries from "../operator_home/recent/RecentEntries";
import "./OperatorHome.css";

const OperatorHome = () => {
  const { isFormOpen } = useContext(FormContext);
  return (
    <div
      className={isFormOpen ? "main-form-container" : "main-operator-container"}
    >
      <Header />
      <Sidebar className="sidebar-operator-home" />
      <TaskSummary />
      <AddBox />
      <RecentEntries />
    </div>
  );
};

export default OperatorHome;
